import request from "@/router/axios";

export const businessUserList = (current, size, params) => {
  return request({
    url: "/api/blade-loanClue/loanClue/business-user-list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: "/api/blade-loanClue/loanClue/detail",
    method: "get",
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/blade-loanClue/loanClue/remove",
    method: "post",
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: "/api/blade-loanClue/loanClue/submit",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/blade-loanClue/loanClue/submit",
    method: "post",
    data: row,
  });
};

//  generator-id-work
export const generatorIdWork = () => {
  return request({
    url: "/api/blade-loanClue/loanClue/generator-id-work",
    method: "get",
  });
};

// clue-save post
export const clueSave = (row) => {
  return request({
    url: "/api/blade-loanClue/loanClue/clue-save",
    method: "post",
    data: row,
  });
};

// findStructAuditDetail
export const findStructAuditDetail = (id, taskId) => {
  return request({
    url: `/api/blade-loanClue/loanClue/find-struct-audit-detail/${id}`,
    method: "get",
    params: {
      taskId,
    },
  });
};
//findStructEditDetail
export const findStructEditDetail = (id) => {
  return request({
    url: `/api/blade-loanClue/loanClue/find-struct-edit-detail/${id}`,
    method: "get",
  });
};

//findStructViewDetail
export const findStructViewDetail = (id) => {
  return request({
    url: `/api/blade-loanClue/loanClue/find-struct-view-detail/${id}`,
    method: "get",
  });
};

//clue-delete/id
export const clueDelete = (id) => {
  return request({
    url: `/api/blade-loanClue/loanClue/clue-delete/${id}`,
    method: "delete",
  });
};

//clueCommitAudit
export const clueCommitAudit = (data, operatorType) => {
  return request({
    url: `/api/blade-loanClue/loanClue/clue-commit-audit/${operatorType}`,
    method: "post",
    data: data,
  });
};


//search-task-definition-key
export const searchTaskDefinitionKey = () => {
  return request({
    url: `/api/blade-loanClue/loanClue/search-task-definition-key`,
    method: "get",
  });
};

// 判断是否能进件
export const isLoanInput = () => {
  return request({
    url: `/api/blade-loanInformation/loanInformation/isLoanInput`,
    method: "get",
  });
};